<template>
  <div>
    <el-form :inline="false" ref="childFormRef" :model="childForm" class="company-info_form" :label-width="getIsMobile?'0':'120px'">
      <el-form-item>
        <el-table :data="modelList" border style="width: 100%; margin-bottom: 10px">
          <el-table-column label="品牌" align="center">
            <template v-slot="scope">
              <el-input v-model="scope.row.source" placeholder="请输入品牌"/>
            </template>
          </el-table-column>
          <el-table-column label="型号" align="center">
            <template v-slot="scope">
              <el-input v-model="scope.row.xhname" placeholder="请输入型号"/>
            </template>
          </el-table-column>
          <el-table-column label="数量" align="center">
            <template v-slot="scope">
              <el-input v-model="scope.row.num" placeholder="请输入数量"/>
            </template>
          </el-table-column>

          <el-table-column label="单价" align="center">
            <template v-slot="scope">
              <el-input v-model="scope.row.price" placeholder="请输入单价"/>
            </template>
          </el-table-column>

          <el-table-column label="总价" align="center">
            <template v-slot="scope">
              <el-input v-model="scope.row.zprice" placeholder="请输入总价" readonly disabled/>
            </template>
          </el-table-column>
          <el-table-column label="货期" align="center">
            <template v-slot="scope">
              <el-input v-model="scope.row.hq" placeholder="请输入货期"/>
            </template>
          </el-table-column>

          <el-table-column label="备注" align="center">
            <template v-slot="scope">
              <el-input v-model="scope.row.bz" placeholder="请输入备注"/>
            </template>
          </el-table-column>

          <el-table-column label="操作" align="center">
            <template v-slot="scope">
              <el-button type="danger" size="small" @click="handleRemove(scope.$index)" class="el-icon-delete">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-form-item>
      <el-button type="primary" @click="addModel" size="small" class="el-icon-plus">增加型号</el-button>
    </el-form>
  </div>
</template>

<script>
import { defineComponent, reactive, ref ,watch} from '@vue/composition-api'
import useRootSetting from '@/hooks/useRootSetting'
export default defineComponent({
  setup() {
    const { getIsMobile } = useRootSetting()
    const childForm = reactive({})
    const address = ref('')
    const modelList = ref([
      { source: '', xhname: '', num: '', price: '', zprice: '', hq: '',bz: '' }
    ])

    // 添加联系人
    const addModel = () => {
      modelList.value.push({ source: '', xhname: '', num: '', price: '', zprice: '', hq: '',bz:'' })
    }

    // 删除联系人
    const handleRemove = (index) => {
      modelList.value.splice(index, 1)
    }

// 计算每行的总价
    watch(
      modelList,
      (newList) => {
        newList.forEach((row) => {
          row.zprice = (row.num || 0) * (row.price || 0);
        });
      },
      { deep: true }
    );

    // 定义一个清空数据的方法
    const clearTable = () => {
      modelList.value.forEach(row => {
        Object.keys(row).forEach(key => {
          row[key] = '' // 清空每一项的值
        })
      })
    }
    return {
      getIsMobile,
      childForm,
      address,
      modelList,
      clearTable,
      addModel,
      handleRemove
    }
  }
})
</script>
<style scoped lang="scss">
.company-info_form {
  padding: 0 60px 60px 20px;
}

.el-icon-plus {
  margin-top:-12px;
  float: right;
}
.model-editor {
  margin-top: 80px;
}

</style>
